import styled from "styled-components";

const S = {
    Wrapper: styled.div`
        /* width: 1024px; */
        /* margin: 20px auto; */
        /* border-radius: 8px; */
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    `,
    Wrapall: styled.div`
        display:grid;
        grid-template-columns: 1fr;
        grid-template-rows: 100px auto;
    `,
    Content: styled.div`
        width: 100%;
        height: 500px;
        padding: 0px;
        float: left;
        box-sizing: border-box;
        //background: $content-backcolor;
        border-radius: 0px 0px 8px 8px;
    `,
    FullHeight: styled.div`
        height: 100%;
        background: #f2f5f4;
        display:flex;
        flex-direction: row;
        /* grid-template-columns:1fr 1fr; */
    `,
    SolPanel: styled.div`
     min-height: 100% !important;
                height: 100%;
                flex-basis:15%;
                /* float: left; */
                box-sizing: border-box;
                background: white;
                border-radius: 0px 0px 0px 8px;
                z-index: 1;
                -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.30);
                ul{
                    list-style: none;
                    float: left;
                    margin: 20px 0px;
                    padding: 0px;
                    li{
                        float: none;
                        opacity: 0.4;
                        transition: 300ms;
                        width: 100%;
                        height: 20px;
                        margin-bottom: 20px;
                        &:hover{
                            opacity: 1;
                            transition: 300ms;
                            .cubuk{
                                opacity: 1;
                                -webkit-box-shadow: 3px 2px 19px 1px #19B5FE;
                                -moz-box-shadow: 3px 2px 19px 1px #19B5FE;
                                box-shadow: 3px 2px 19px 1px #19B5FE;
                            }
                        }
                        .cubuk{
                            float: left;
                            width: 3px;
                            height: 100%;
                            /* margin-right: 20px; */
                            background: #19B5FE;
                            box-sizing: border-box;
                            opacity: 0;
                            -webkit-box-shadow: 3px 2px 19px 1px #19B5FE;
                            -moz-box-shadow: 3px 2px 19px 1px #19B5FE;
                            box-shadow: 3px 2px 19px 1px #19B5FE;
                        }
                        img{
                            width: 15px;
                            height: 15px;
                            float: left;
                            padding-top:13px;
                        }
                        input[type="submit"]{
                            width: auto;
                            background: white;
                            border-radius: 8px;
                            border-style:none;
                            padding: 0px 20px;
                            text-decoration: none;
                            font-size: 15px;
                            box-sizing:border-box;
                            font-weight: 600;
                            color:#28302c;
                            cursor:pointer;
                        }:focus {
                           outline:0;
                        }
                    }
                }
    `,
    ContentList: styled.div`
                /* float: left; */
                /* width: 800px; */
                display: flex;
                flex-direction:column;
                flex-basis:85%;
                height: 500px;
                /* right: 4px; */
                overflow-y: auto;
                overflow-x:hidden;
                .icerik{
                    /* float: left; */
                    overflow-y: auto;
                    overflow-x:hidden;
                    box-sizing: border-box;
                    /* width:700px; */
                    height: 500px;
                    padding-left:20px;
                    /* display: table; */
                    ul{
                        width: 100%;
                        margin:0;
                        padding:0;
                        li{
                            background-color: white;
                            width: 100%;
                            margin-top: 10px;
                            border-radius: 4px;
                            padding: 15px;
                            box-sizing: border-box;
                            transition: 500ms;
                            &:hover{
                                background-color: #19B5FE;
                                transition: 500ms;
                                -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                .raportasiyici{
                                    width: 80%;
                                    float: left;
                                    .adi{
                                        color:white;
                                    }
                                    .tarih{
                                        color:white;
                                    }
                                }
                            }
                            .raportasiyici{
                                width: 80%;
                                float: left;
                                cursor:pointer;
                                .adi{
                                    width: 100%;
                                    float: left;
                                    color:#19B5FE;
                                    font-size:14px;
                                    font-weight: 600;
                                    cursor:default;
                                }
                                .tarih{
                                    width: 100%;
                                    float: left;
                                    padding-top:5px;
                                    color:#28302c;
                                    font-size:14px;
                                    font-weight: 600;
                                    cursor:default;
                                }
                            }
                            .indirbuton{
                            float: right;
                            width: auto;
                            background: none;
                            border-radius: 8px;
                            border-style:none;
                            padding: 12px 20px;
                            text-decoration: none;
                            font-size: 15px;
                            box-sizing:border-box;
                            font-weight: 600;
                            color:#28302c;
                            cursor:pointer;
                            }:focus {
                            outline:0;
                            }
                        }
                    }
                }
                .listebilgi{
                        padding: 45px;
                        box-sizing: border-box;
                        float: left;
                        color:#b8bdbb;
                }
    `,
    RaporSilPanel: styled.div`
                width: 100%;
                height: 500px;
                float: left;
                background: #f2f5f4;
                .raporarama{
                    opacity: 0.4;
                    width: 100%;
                    float: left;
                    box-sizing: border-box;
                    padding: 15px;
                    height: auto;
                    transition: 300ms;
                    img{
                        opacity: 0.3;
                        width: 20px;
                        height: 20px;
                        float: left;
                        margin-right: 15px;
                        transition: 300ms;
                    }
                    input[type="text"]{
                        width: 95%;
                        float: left;
                        border-top: 0px;
                        border-left: 0px;
                        border-right: 0px;
                        border-bottom:1px solid #b8bdbb;
                        transition: 300ms;
                        text-indent: 20px;
                        font-size: 18px;
                        box-sizing: border-box;
                        transition: 300ms;
                        background: none;
                    }:focus {
                           outline:0;
                    }
                    &:hover{
                        opacity: 1;
                        background: white;
                    img{
                        opacity: 1;
                    }
                    input[type="text"]{
                        opacity: 1;
                        transition: 300ms;
                        border-bottom:2px solid #19B5FE;
                    }
                    }
                }
                .kurumedit{
                    width: 100%;
                    float: left;
                    box-sizing: border-box;
                    padding: 15px;
                    height: auto;
                    input[type="text"]{
                        width: 48%;
                        float: left;
                        border-top: 0px;
                        border-left: 0px;
                        border-right: 0px;
                        border-bottom:1px solid #b8bdbb;
                        transition: 300ms;
                        text-indent: 20px;
                        font-size: 18px;
                        box-sizing: border-box;
                        transition: 300ms;
                        background: none;
                        margin-right: 10px;
                    }:focus {
                           outline:0;
                    }
                    input[type="submit"]{
                            float: left;
                            width: 100%;
                            background: #19B5FE;
                            border-radius: 4px;
                            border-style:none;
                            padding: 12px 20px;
                            text-decoration: none;
                            font-size: 15px;
                            box-sizing:border-box;
                            font-weight: 600;
                            margin-top:10px;
                            color:white;
                            cursor:pointer;
                            transition: 300ms;
                            &:hover{
                                transition: 300ms;
                                color:#28302c;
                                background: #f2f5f4;
                            }
                    }:focus {
                        outline:0;
                    }
                }
                .contentlist{
                    float: right;
                    width: 100%;
                    box-sizing: border-box;
                    height: 440px;
                    right: 4px;
                    overflow-y: auto;
                    overflow-x:hidden;
                    .icerik{
                        float: left;
                        overflow-y: auto;
                        overflow-x:hidden;
                        box-sizing: border-box;
                        width:100%;
                        height: 300px;
                        display: table;
                        ul{
                            width: 100%;
                            margin:0;
                            padding: 20px;
                            box-sizing: border-box;
                            li{
                                background-color: white;
                                width: 100%;
                                margin-top: 10px;
                                border-radius: 4px;
                                padding: 15px;
                                box-sizing: border-box;
                                transition: 500ms;
                                &:hover{
                                    background-color: #19B5FE;
                                    transition: 500ms;
                                    -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    .raportasiyici{
                                        width: 80%;
                                        float: left;
                                        .adi{
                                            color:white;
                                        }
                                        .tarih{
                                            color:white;
                                        }
                                    }
                                }
                                .raportasiyici{
                                    width: 80%;
                                    float: left;
                                    cursor:pointer;
                                    .adi{
                                        width: auto;
                                        float: left;
                                        padding: 4px 0px 0px 10px;
                                        color:#19B5FE;
                                        font-size:14px;
                                        font-weight: 600;
                                        cursor:default;
                                    }
                                    .tarih{
                                        width: auto;
                                        float: left;
                                        padding: 4px 0px 0px 10px;
                                        color:#28302c;
                                        font-size:14px;
                                        font-weight: 600;
                                        cursor:default;
                                    }
                                }
                                .indirbuton{
                                    float: right;
                                    width: auto;
                                    background: none;
                                    border-radius: 8px;
                                    border-style:none;
                                    padding: 0px 10px;
                                    text-decoration: none;
                                    font-size: 15px;
                                    box-sizing:border-box;
                                    font-weight: 600;
                                    color:#28302c;
                                    cursor:pointer;
                                }:focus {
                                    outline:0;
                                }
                                .silbuton{
                                    float: right;
                                    width: auto;
                                    background: none;
                                    border-radius: 8px;
                                    border-style:none;
                                    padding: 0px 10px;
                                    text-decoration: none;
                                    font-size: 15px;
                                    box-sizing:border-box;
                                    font-weight: 600;
                                    color:#28302c;
                                    cursor:pointer;
                                }:focus {
                                    outline:0;
                                }
                            }
                        }
                    }
                    .listebilgi{
                        padding: 45px;
                        box-sizing: border-box;
                        float: left;
                        color:#b8bdbb;
                    }
                }
                .contentlistkurum{
                    float: right;
                    width: 100%;
                    box-sizing: border-box;
                    height: 335px;
                    right: 4px;
                    overflow-y: auto;
                    overflow-x:hidden;
                    .icerik{
                        float: left;
                        overflow-y: auto;
                        overflow-x:hidden;
                        box-sizing: border-box;
                        width:100%;
                        height: 300px;
                        display: table;
                        ul{
                            width: 100%;
                            margin:0;
                            padding: 20px;
                            box-sizing: border-box;
                            li{
                                background-color: white;
                                width: 100%;
                                margin-top: 10px;
                                border-radius: 4px;
                                padding: 15px;
                                box-sizing: border-box;
                                transition: 500ms;
                                &:hover{
                                    background-color: #19B5FE;
                                    transition: 500ms;
                                    -webkit-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    -moz-box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    box-shadow: 10px 0px 85px -29px rgba(0,0,0,0.50);
                                    .raportasiyici{
                                        width: 80%;
                                        float: left;
                                        .adi{
                                            color:white;
                                        }
                                        .tarih{
                                            color:white;
                                        }
                                    }
                                }
                                .raportasiyici{
                                    width: 80%;
                                    float: left;
                                    cursor:pointer;
                                    .adi{
                                        width: auto;
                                        float: left;
                                        padding: 4px 0px 0px 10px;
                                        color:#19B5FE;
                                        font-size:14px;
                                        font-weight: 600;
                                        cursor:default;
                                    }
                                    .tarih{
                                        width: auto;
                                        float: left;
                                        padding: 4px 0px 0px 10px;
                                        color:#28302c;
                                        font-size:14px;
                                        font-weight: 600;
                                        cursor:default;
                                    }
                                }
                                .indirbuton{
                                    float: right;
                                    width: auto;
                                    background: none;
                                    border-radius: 8px;
                                    border-style:none;
                                    padding: 0px 10px;
                                    text-decoration: none;
                                    font-size: 15px;
                                    box-sizing:border-box;
                                    font-weight: 600;
                                    color:#28302c;
                                    cursor:pointer;
                                }:focus {
                                    outline:0;
                                }
                                .silbuton{
                                    float: right;
                                    width: auto;
                                    background: none;
                                    border-radius: 8px;
                                    border-style:none;
                                    padding: 0px 10px;
                                    text-decoration: none;
                                    font-size: 15px;
                                    box-sizing:border-box;
                                    font-weight: 600;
                                    color:#28302c;
                                    cursor:pointer;
                                }:focus {
                                    outline:0;
                                }
                            }
                        }
                    }
                    .listebilgi{
                        padding: 45px;
                        box-sizing: border-box;
                        float: left;
                        color:#b8bdbb;
                    }
                }
    `
}

export default S